import React, { Component } from 'react'

import CSSModules from 'react-css-modules'
import _ from 'lodash'
import {
  IconButton
} from 'react-toolbox'
import FulcrumDivider from 'components/fulcrum/divider/Divider'

import Input from 'components/fulcrum/input/Input'

import FormTitle from 'components/fulcrum/formTitle/FormTitle'
import ConfigTable from './ConfigTable'
import styles from './styles.scss'

import T from 'i18n-react' 
import { 
  MP_FIELDS, 
  MP_FIELDS_INT_ATTR, 
  TITLE,
  ADD_POWER_ON,
  ADD_POWER_OFF,
  POWER_ON_BREAKDOWN,
  POWER_OFF_BREAKDOWN,
  REMOVE,
  HEADERS
} from './constants'

class MissionProfileConfigItem extends Component {

  mpUpdate = (index, type, val) => {
    if (MP_FIELDS_INT_ATTR.includes(type) && val !== '') {
      val = parseInt(val)
      if (!val) return
    }
    this.props.mpUpdate(index, type, val)
  }

  generateMissionProfileRow = () => {
    const {
      value,
      index,
    } = this.props

    return (
      <React.Fragment>
        {
          MP_FIELDS.map(element => {
            const key = `mp${index}${element}`
            const title = T.translate(`${HEADERS}.${element}`)
            const onChange = this.mpUpdate.bind(this, index, element)
            const type = MP_FIELDS_INT_ATTR.includes(element) ? "number" : "text"
            const val = !value[element] && value[element] !== 0 ? '' : value[element]
            return (
              <FormTitle key={key} title={title}>
                <Input
                  placeholder={""}
                  value={val}
                  onChange={onChange}
                  type={type}
                />
              </FormTitle>
            )})
        }
      </React.Fragment>
    )
  }

  getConfigItemDel = (idx) => {
    const {
      mpRemove
    } = this.props

    return (
      <span styleName="deleteSpan">
        <IconButton styleName="deleteBtn" icon='delete' onClick={mpRemove.bind(this, idx)} primary />
      </span>
    )
  }

  render() {
    const {
      value,
      index,
      mpRemove,
      powerOnAdd,
      powerOnRemove,
      powerOnUpdate,
      powerOffAdd,
      powerOffRemove,
      powerOffUpdate
    } = this.props

    const configTitle=`${T.translate(TITLE)}${index + 1}`

    const addPowerOn = T.translate(ADD_POWER_ON)
    const addPowerOff = T.translate(ADD_POWER_OFF)

    const powerOnBreakdown = T.translate(POWER_ON_BREAKDOWN)
    const powerOffBreakdown = T.translate(POWER_OFF_BREAKDOWN)

    const remove = `(${T.translate(REMOVE)})`

    return (
      <div>
        <div>
          {this.getConfigItemDel(index)}
          {/* <span styleName='configTitle'>{`${configTitle} `}</span>
          <a styleName='addConfig' onClick={mpRemove.bind(this,index)}>{remove}</a> */}
        </div>
        {/* TODO: change to trash can */}
        {this.generateMissionProfileRow()}
        <ConfigTable
          title={powerOnBreakdown}
          values={value.powerOn}
          mpIndex={index}
          onAdd={powerOnAdd.bind(this, index)}
          onRemove={powerOnRemove.bind(this, index)}
          onEdit={powerOnUpdate.bind(this, index)}
          addBtnText={addPowerOn}
        />
        <ConfigTable
          title={powerOffBreakdown}
          values={value.powerOff}
          mpIndex={index}
          onAdd={powerOffAdd.bind(this, index)}
          onRemove={powerOffRemove.bind(this, index)}
          onEdit={powerOffUpdate.bind(this, index)}
          addBtnText={addPowerOff}
        />
        <FulcrumDivider />
      </div>
    )
  }
}

export default CSSModules(MissionProfileConfigItem, styles)
